<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between">
            <div>
              <h3 class="card-title text-primary mb-0">Nueva Experiencia</h3>
              <div class="sub-line"></div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-sm mx-60">
              <experience-form :entity="newExperience" action="create" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import ExperienceForm from "./ExperienceForm.vue";

    const newExperience = ref({
      name: null,
      trail: null,
      type: {id: 1},
      lang: 'es',
      latitude: null,
      longitude: null
    });

</script>
